<template>
  <div class="menuItem" :class="{notPointer: icon.includes('grey')}">
    <!-- Menu item disabled -->
    <div v-if="disabled"
      view="#main-view">
      <div
        :id="label.replace(/ /g, '')"
        :style="backgroundStyleClick"
        :class="isBoxRequest"
        class="roundHover whiteHover">
        <div style="filter: invert(60%)">
          <i :icon="iconClass" class="primary-icon" v-bind:style="backgroundStyleClick"></i>
          <f7-label :style="'font-size: ' + labelStyle.size + 'px; color: grey'">{{ label }}</f7-label>
        </div>
      </div>
      <span class="numberBadge" v-if="showNumberBadge && notificationNumber !== '0'"> {{ this.notificationNumber }} </span>
    </div>

    <!-- Menu item enabled -->
    <f7-link v-else
      view="#main-view" @click="updatePage(clickAction)" :close-panel="closePanel" :close-popup="closePopup">
      <div
        :id="label.replace(/ /g, '')"
        :style="backgroundStyleClick"
        :class="isBoxRequest"
        class="roundHover">
        <div :style="switchToWhite">
          <i :icon="iconClass" class="primary-icon" ></i>
          <f7-label :style="'font-size: ' + labelStyle.size + 'px; color: ' + labelStyle.color">{{ label }}</f7-label>
        </div>
      </div>
      <span class="numberBadge" v-if="showNumberBadge && notificationNumber !== '0'"> {{ this.notificationNumber }} </span>
    </f7-link>
  </div>
</template>

<script>
import {loadPage} from '@/helpers/routing'

export default {
  name: 'menuItem',
  props: {
    link: {
      type: String,
      default: ''
    },
    service: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'help'
    },
    iconStyle: {
      type: Object,
      default: () => ({
        size: '50',
        color: 'black'
      })
    },
    label: {
      type: String,
      default: 'No Name'
    },
    labelStyle: {
      type: Object,
      default: () => ({
        size: '4',
        color: 'black'
      })
    },
    closePanel: {
      type: Boolean,
      default: false
    },
    closePopup: {
      type: Boolean,
      default: false
    },
    clickAction: {
      type: Object,
      default: () => ({
        name: 'changePage',
        value: ''
      })
    },
    labelIcon: {
      type: Object,
      default: () => ({
        name: '',
        color: 'green'
      })
    },
    showNumberBadge: {
      type: Boolean,
      default: false
    },
    emit: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    backGroundColor: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      notificationNumber: '0'
    }
  },
  mounted () {
    /* TLV 07/08/2020 & 08/09/2020
    * Evenement qui rafraîchit les notifications a partir du nombre de notifications
    * envoyé en paramètre.
    * */
    this.$bus.$on('updateNotificationNumber', (newNotificationNumber) => {
      if (parseInt(newNotificationNumber) > 99) {
        this.notificationNumber = '99+'
      } else {
        this.notificationNumber = newNotificationNumber
      }
    })
  },
  computed: {
    iconClass () {
      return 'icon-' + this.icon
    },
    /* TLV 09/03/2020
    * @brief Propriété calculée (computed) qui va déterminer la couleur de fond
    *   de la pastille lorsque l'utilisateur clique sur un item du panneau de gauche
    * La couleur est prélevée dans le fichier .json correspondant si elle y est indiquée, sinon c'est
    * la couleur du service comme précisé dans le json defaultBackgroundcolorMatchings défini ci-dessous
    */
    backgroundStyleClick () {
      if (this.active) {
        let backGroundColorOnClick = {
          boxShadow: '0px 0px 2px #888',
          borderRadius: '20px'
        }
        if (this.backGroundColor) {
          backGroundColorOnClick['backgroundColor'] = this.backGroundColor
        } else {
          let defaultBackgroundcolorMatchings = {
            '6': '#12BCF1',
            '1': '#51A45C',
            '2': '#572B74'
          }
          backGroundColorOnClick['backgroundColor'] = defaultBackgroundcolorMatchings[this.$engine.user.currentService.id]
        }
        return backGroundColorOnClick
      }
      // Si le bouton n'est pas actif,  on enleve le pointeur de souris
      return {cursor: 'default'}
    },
    /** TLV 11/03/2020
    * @brief Propriété calculée (computed) qui passe les contours de l'icône en
    * blanc sur un item sélectionné
    */
    switchToWhite () {
      if (this.active) {
        return {WebkitFilter: 'invert(100%)'}
      }
      return {}
    },
    /* TLV 09/03/2020
    * @brief computed property indiquant si on met un fond coloré au passage de la souris (inutile si l'item est disabled)
    */
    isBoxRequest () {
      let className = ''
      if (!this.icon.includes('grey')) {
        className += ' boxRequest'
      }
      return className
    }
  },
  methods: {
    /* @brief Méthode qui change soit la page (dans le cas d'un clic sur un des items du panneau de gauche),
      soit le service (dans le cas d'un clic sur la pop-up de service switcher).
      Si l'attribut 'name' du paramètre action vaut 'doNothing', cette fonction ne fait rien
      (ce qui sert dans le cas d'un item grisé sur la pop-up de changement de service par exemple). */
    updatePage (action) {
      if (action.name !== 'doNothing') {
        if (this.emit !== '') {
          this.$bus.emit(this.emit)
        }
        this.$engine.services.payments.filter.cleanFilterCondition()
        this.$engine.services.directPayments.filter.cleanFilterCondition()
        loadPage(this, {url: this.link})
        switch (action.name) {
          case 'changeService':
            this.$engine.user.changeService(action.value)
            this.$bus.emit('service:change', action.value.name)
            break
          case 'changePage':
            break
          default:
        }
      }
    }
  }
}
</script>

<style scoped>

a {
  background-color: inherit;
}

.menuItem a > .label {
  color: black;
  /* margin-top: 5px; */
}
.menuItem {
  margin-top: 25px;
  /* padding: 14px 11px;
  padding: 14px 0px 14px 25px; */
  height: 40px;
  padding-top: 12px;
  padding-bottom: 12px;
}
/* #firstIcon {
  position: relative;
} */
#secondIcon {
  position: absolute;
  top: 0px;
  right: -5px;
  font-size: 15px;
}
.primary-icon {
  width: 40px;
  height: 40px;
  background-size: contain;
}
.left-icon {
  width: 50px;
  height: 50px;
  background-size: contain;
}
.numberBadge {
  position: relative;
  top: -60px;
  right: -52px;
  border-radius: 25%;
  border: 1px solid #e53f4e;
  color: #ffffff;
  text-align: center;
  background-color: #e53f4e;
  min-width: 19px;
  text-align: center;
  display: inline-block;
  /* padding-right: 1px; */
}
.whiteHover {
  background-color: white;
}
.icon-moneyroad {
  background-image: url('../../assets/static/images/logo/mrlogo.png');
}

/* TLV 04/03/2020
* Ajustements sur l'icône de service violet pour résoudre des problèmes de taille
*/
.icon-sepa {
  margin-top: 2px;
  height: 35px;
  margin-bottom: 3px;
  background-image: url('../../assets/static/images/logo/SEPA_purple.svg');
}
.icon-sepa-grey {
  background-image: url('../../assets/static/images/logo/SEPA_grey.png');
}
.icon-invoicedirect-grey {
  background-image: url('../../assets/static/images/logo/invoicedirect_grey.png');
}
.icon-payments {
  background-image: url('../../assets/static/images/logo/payments.png');
}
.icon-payments-grey {
  background-image: url('../../assets/static/images/logo/payments-grey.png');
}
.icon-exchangedoc {
  background-image: url('../../assets/static/images/logo/exchangeDoc.png');
}
.icon-exchangedoc-grey {
  background-image: url('../../assets/static/images/logo/exchangeDoc-grey.png');
}
.icon-clouddoc {
  background-image: url('../../assets/static/images/logo/cloudDoc.png');
}
.icon-payslip {
  background-image: url('../../assets/static/images/logo/payslip.png');
}
.icon-dashboard {
  /* background-image: url('../../assets/static/images/icons/dashboard.png'); */
  background-image: url('../../assets/static/images/icons/gauge.png');
}
.icon-send {
  /* background-image: url('../../assets/static/images/icons/send.png'); */
  background-image: url('../../assets/static/images/icons/mail_write.png');
}
.icon-inbox {
  /* background-image: url('../../assets/static/images/icons/inbox.png'); */
  background-image: url('../../assets/static/images/icons/inbox_into.png');
}
.icon-sent {
  /* background-image: url('../../assets/static/images/icons/sentbox.png'); */
  background-image: url('../../assets/static/images/icons/inbox_out.png');
}
.icon-account {
  /* background-image: url('../../assets/static/images/icons/account.png'); */
  background-image: url('../../assets/static/images/icons/id_badge.png');
}
.icon-accounts {
  /* background-image: url('../../assets/static/images/icons/accounts.png'); */
  background-image: url('../../assets/static/images/icons/users_relation.png');
}
.icon-attachment {
  /* background-image: url('../../assets/static/images/icons/attachment.png'); */
  background-image: url('../../assets/static/images/icons/paperclip.png');
}
.icon-banks {
  /* background-image: url('../../assets/static/images/icons/banks.png'); */
  background-image: url('../../assets/static/images/icons/credit_cards.png');
}
.icon-contacts {
  /* background-image: url('../../assets/static/images/icons/contacts.png'); */
  background-image: url('../../assets/static/images/icons/address_book2.png');
}
.icon-settings {
  /* background-image: url('../../assets/static/images/icons/settings.png'); */
  background-image: url('../../assets/static/images/icons/gearwheels.png');
}
.icon-signout {
  background-image: url('../../assets/static/images/icons/signout.png');
}
.icon-logout {
  background-image: url('../../assets/static/images/icons/door_exit.png');
}
.icon-trash {
  background-image: url('../../assets/static/images/icons/trash.png');
}
.icon-draft {
  /* background-image: url('../../assets/static/images/icons/draft.png'); */
  background-image: url('../../assets/static/images/icons/inkpot.png');
}
.icon-accountmembers {
  /* background-image: url('../../assets/static/images/icons/membersAccounts.png'); */
  background-image: url('../../assets/static/images/icons/users5.png');
}
.icon-pilotage {
  /* background-image: url('../../assets/static/images/icons/pilotage.png'); */
  background-image: url('../../assets/static/images/icons/compass.png');
}
.icon-echeancier {
  background-image: url('../../assets/static/images/icons/bookmarks.png');
}
.icon-verifications {
  background-image: url('../../assets/static/images/icons/icon_identite_black.png');
}
</style>
